"use client";

export default function DecorativeLines() {
  return (
    <>
      {/* Editorial Decorative Elements (absolute so they scroll with section) */}
      <div className="absolute top-40 right-32 w-12 h-1 bg-black/15 animate-float" />
      <div className="absolute top-1/2 left-8 w-1 h-24 bg-black/10 animate-bounce-gentle" />
      <div
        className="absolute bottom-32 right-16 w-8 h-1 bg-black/12 animate-float"
        style={{ animationDelay: "3s" }}
      />
      <div
        className="absolute top-1/4 right-1/4 w-1 h-16 bg-black/8 animate-bounce-gentle"
        style={{ animationDelay: "1.5s" }}
      />
    </>
  );
}
